exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /Users/jb/Code/grupob/~/core-js/modules/_wks-ext.js
// module id = 125
// module chunks = 0